export const en = {
    'placeholder.suggest_kontur': 'Enter the INN or company name',
};
